/* Theme-owned ITORIS integration. Preserve the original controls, values and event handlers.
   ITORIS renders asynchronously; repair semantics again when it replaces field markup. */
(() => {
  if (window.vdProductOptionSemantics) return;
  window.vdProductOptionSemantics = true;
  const host = document.querySelector('main');
  if (!host) return;
  const errorStatus = document.createElement('p');
  errorStatus.className = 'visually-hidden';
  errorStatus.setAttribute('role','alert');
  host.append(errorStatus);
  let scheduled = false;
  const set = (el, name, value) => {
    if (el.getAttribute(name) !== value) el.setAttribute(name, value);
  };
  function update() {
    scheduled = false;
    observer.disconnect();
    try {
      const errors = [];
      host.querySelectorAll('.uploadkit-button img:not([alt])').forEach(img => img.alt = '');
      host.querySelectorAll('#itoris_dynamicproductoptions [id^="dynamic_option_id_"]').forEach(field => {
        const heading = field.querySelector(':scope > label');
        const controls = [...field.querySelectorAll('input:not([type="hidden"]),select,textarea')];
        if (!controls.length) return;
        let advice = field.querySelector('.validation-advice');
        // The vendor leaves its required-selection message behind after a valid choice.
        // Clear only that exact error on a non-empty native select; other validation stays vendor-owned.
        if (advice && controls.length === 1 && controls[0].tagName === 'SELECT' && controls[0].value && advice.textContent.trim() === 'This field is required') {
          advice.remove();
          controls[0].classList.remove('dpo-error');
          advice = null;
        }
        if (advice && !advice.getClientRects().length) advice = null;
        const errorId = `VD-Error-${field.id}`;
        if (advice) {
          advice.id = errorId;
          const label = field.querySelector('label,legend')?.textContent.replace(/[?*]/g,'').trim() || 'Product option';
          errors.push(`${label}: ${advice.textContent.trim()}`);
        }
        controls.forEach(control => {
          const described = (control.getAttribute('aria-describedby') || '').split(/\s+/).filter(id => id && id !== errorId);
          if (advice) described.push(errorId);
          if (described.length) set(control,'aria-describedby',described.join(' '));
          else control.removeAttribute('aria-describedby');
          if (advice) { set(control,'aria-invalid','true'); control.dataset.vdA11yError = 'true'; }
          else if (control.dataset.vdA11yError) { control.removeAttribute('aria-invalid'); delete control.dataset.vdA11yError; }
        });
        const radios = controls.filter(el => el.type === 'radio');
        if (heading && radios.length === controls.length && !field.querySelector('fieldset')) {
          const group = document.createElement('fieldset');
          group.className = 'vd-option-fieldset';
          const legend = document.createElement('legend');
          legend.className = heading.className;
          while (heading.firstChild) legend.append(heading.firstChild);
          group.append(legend);
          heading.replaceWith(group);
          // Move only the existing control wrapper; controls and their listeners are retained.
          const wrapper = field.querySelector(':scope > .control');
          if (wrapper) group.append(wrapper);
        } else if (heading && controls.length === 1 && controls[0].id) {
          set(heading, 'for', controls[0].id);
        }
        // Expose vendor-required fields with native radio group constraints and accessible select state.
        controls.forEach(control => {
          let required = false;
          try { required = JSON.parse(control.getAttribute('validation') || '{}').required === true; } catch {}
          if (radios.includes(control)) {
            try { required ||= JSON.parse(control.closest('[validation]')?.getAttribute('validation') || '{}').required === true; } catch {}
          }
          if (required && control.type !== 'radio') set(control, 'aria-required', 'true');
          if (required && control.type === 'radio') control.required = true;
        });
      });
      const message = errors.join(' ');
      if (errorStatus.textContent !== message) errorStatus.textContent = message;
    } finally {
      observer.observe(host, {childList:true,subtree:true,attributes:true,attributeFilter:['class','style','hidden']});
    }
  }
  const schedule = () => {
    if (!scheduled) { scheduled = true; queueMicrotask(update); }
  };
  const observer = new MutationObserver(schedule);
  host.addEventListener('change',schedule);
  update();
})();
